import { render, staticRenderFns } from "./CompTabular.vue?vue&type=template&id=12133ddd&"
import script from "./CompTabular.vue?vue&type=script&lang=js&"
export * from "./CompTabular.vue?vue&type=script&lang=js&"
import style0 from "./CompTabular.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports